import { IBaseFile } from '@vandelft/shared/interfaces/base-file';
import { Expose } from 'class-transformer';

export abstract class BaseFile implements IBaseFile {
  @Expose()
  id: string;
  isLocal: boolean;
  deleted?: Date;
}
